// Try it free teaser: one animation, used on the website and rendered to video for social media.
// Pure JavaScript (no React) so the same file can be rendered to MP4 and GIF files.
const T = 12; // seconds per loop
const p = (t) => ((t / T) * 100).toFixed(3);
let kfs = '';
let n = 0;
const kf = (start, end, rise = 3) => {
  const name = `tf${n++}`;
  const fi = 0.45, fo = 0.35;
  kfs += `@keyframes ${name}{0%{opacity:0;transform:translateY(calc(var(--u)*${rise}))}${p(start)}%{opacity:0;transform:translateY(calc(var(--u)*${rise}))}${p(start + fi)}%{opacity:1;transform:none}${p(end - fo)}%{opacity:1;transform:none}${p(end)}%{opacity:0;transform:none}100%{opacity:0}}`;
  return `animation:${name} ${T}s linear infinite`;
};

const PARTS = ['Begin the journey', 'Build your farm', 'Feed and keep healthy', 'Breed and multiply', 'Manage with data', 'Add value', 'Fund and grow', 'Practise and graduate'];

export function teaserHtml({ img = '/academy/goat-portrait.jpg', social = false } = {}) {
  kfs = ''; n = 0;
  const A = [0, 2.9], B = [2.9, 6.1], C = [6.1, 9.5], D = [9.5, 12];
  const s = (sc, delay, rise) => `style="${kf(sc[0] + delay, sc[1], rise)}"`;
  const parts = PARTS.map((t, i) => `<div class="tf-part" ${s(C, 1.0 + i * 0.22, 2)}><b>${i + 1}</b><span>${t}</span></div>`).join('');
  const html = `
<div class="tf" aria-hidden="true">
  <div class="tf-bg"></div>
  <!-- Scene A -->
  <div class="tf-sc">
    <img class="tf-photo" src="${img}" alt="" ${s(A, 0, 2)}>
    <div class="tf-h" ${s(A, 0.25)}>Learn dairy goats.<br>Try one lesson free.</div>
    <div ${s(A, 0.7)}><span class="tf-btn tf-pulse">Try it free &rarr;</span></div>
    <div class="tf-chips" ${s(A, 1.0)}><span>Free</span><span>No sign-in</span><span>3 minutes</span></div>
  </div>
  <!-- Scene B -->
  <div class="tf-sc">
    <div class="tf-h" ${s(B, 0)}>Try it in 3 easy steps</div>
    <div class="tf-step" ${s(B, 0.5)}><i>1</i><span>Tap the orange button</span></div>
    <div class="tf-step" ${s(B, 1.1)}><i>2</i><span>Read 4 short lessons</span></div>
    <div class="tf-step" ${s(B, 1.7)}><i>3</i><span>Answer 6 easy questions</span></div>
  </div>
  <!-- Scene C -->
  <div class="tf-sc">
    <div class="tf-eb" ${s(C, 0)}>The full MbuziPlus Course</div>
    <div class="tf-nums" ${s(C, 0.2)}><div><b>8</b><span>parts</span></div><div><b>42</b><span>modules</span></div><div><b>172</b><span>study hours</span></div></div>
    <div class="tf-parts">${parts}</div>
  </div>
  <!-- Scene D -->
  <div class="tf-sc">
    <div class="tf-badge" ${s(D, 0, 2)}>Certificate of Completion</div>
    <div class="tf-h" ${s(D, 0.35)}>Start with one free lesson</div>
    <div ${s(D, 0.7)}><span class="tf-btn tf-pulse">Try it free &rarr;</span></div>
    ${social ? `<div class="tf-pay" ${s(D, 1.0)}>Full course: Kenya Shillings 4,900<br>Pay safely with Paystack: M-Pesa, card or bank</div>` : ''}
    <div class="tf-url" ${s(D, social ? 1.3 : 1.0)}>www.imfuyo.farm/academy</div>
  </div>
</div>`;
  const css = `
.tf-box{width:100%;container-type:size;--u:min(1cqw,0.8cqh);overflow:hidden;position:relative;border-radius:calc(var(--u)*3);font-family:'Inter','DejaVu Sans',system-ui,sans-serif}
.tf{position:absolute;inset:0;color:#fff}
.tf-bg{position:absolute;inset:0;background:radial-gradient(120% 90% at 50% 0%,#285020 0%,#14301A 62%)}
.tf-sc{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:calc(var(--u)*3.2);padding:calc(var(--u)*6) calc(var(--u)*7);text-align:center}
.tf-tall .tf-sc{padding-block:calc(var(--u)*22)}
.tf-sc>*{opacity:0}
.tf-sc>.tf-parts{opacity:1}
.tf-photo{width:calc(var(--u)*78);height:calc(var(--u)*32);object-fit:cover;object-position:50% 40%;border-radius:calc(var(--u)*3);border:calc(var(--u)*.8) solid #fff;max-width:100%}
.tf-h{font-size:calc(var(--u)*7.4);line-height:1.08;font-weight:800;letter-spacing:-.02em;text-wrap:balance}
.tf-eb{font-size:calc(var(--u)*4);font-weight:800;letter-spacing:.14em;text-transform:uppercase;color:#F4A261}
.tf-btn{display:inline-block;background:#BF4700;color:#fff;font-weight:800;font-size:calc(var(--u)*6.6);padding:calc(var(--u)*2.8) calc(var(--u)*7);border-radius:999px}
.tf-pulse{animation:tfpulse 1.6s ease-out infinite}
@keyframes tfpulse{0%{box-shadow:0 0 0 0 rgba(244,162,97,.7)}70%{box-shadow:0 0 0 calc(var(--u)*3.5) rgba(244,162,97,0)}100%{box-shadow:0 0 0 0 rgba(244,162,97,0)}}
.tf-chips{display:flex;gap:calc(var(--u)*2);flex-wrap:wrap;justify-content:center}
.tf-chips span{background:#F4F0E6;color:#14301A;font-weight:800;font-size:calc(var(--u)*3.8);padding:calc(var(--u)*1.2) calc(var(--u)*3);border-radius:999px}
.tf-step{display:flex;align-items:center;gap:calc(var(--u)*3);background:#F4F0E6;color:#14301A;border-radius:calc(var(--u)*3);padding:calc(var(--u)*2.6) calc(var(--u)*3.6);width:calc(var(--u)*84);max-width:100%;text-align:left}
.tf-step i{flex:none;width:calc(var(--u)*9);height:calc(var(--u)*9);border-radius:50%;background:#BF4700;color:#fff;font-style:normal;font-weight:800;font-size:calc(var(--u)*5.6);display:grid;place-items:center}
.tf-step span{font-weight:800;font-size:calc(var(--u)*5.2);line-height:1.15}
.tf-nums{display:flex;gap:calc(var(--u)*2.4);justify-content:center}
.tf-nums div{background:#F4F0E6;color:#14301A;border-radius:calc(var(--u)*3);padding:calc(var(--u)*2.2) calc(var(--u)*2.2);min-width:calc(var(--u)*24)}
.tf-nums b{display:block;font-size:calc(var(--u)*10);line-height:1;color:#BF4700;font-weight:800}
.tf-nums span{font-weight:800;font-size:calc(var(--u)*3.3)}
.tf-parts{display:grid;grid-template-columns:1fr 1fr;gap:calc(var(--u)*1.6) calc(var(--u)*2);width:calc(var(--u)*86);max-width:100%}
.tf-part{display:flex;align-items:center;gap:calc(var(--u)*1.6);background:rgba(255,255,255,.12);border-radius:calc(var(--u)*2);padding:calc(var(--u)*1.5) calc(var(--u)*2);text-align:left}
.tf-part b{flex:none;width:calc(var(--u)*5.6);height:calc(var(--u)*5.6);border-radius:50%;background:#F4A261;color:#14301A;display:grid;place-items:center;font-size:calc(var(--u)*3.4)}
.tf-part span{font-weight:700;font-size:calc(var(--u)*3.4);line-height:1.15}
.tf-badge{background:#F4A261;color:#14301A;font-weight:800;font-size:calc(var(--u)*4.6);padding:calc(var(--u)*1.6) calc(var(--u)*4.4);border-radius:999px;text-transform:uppercase;letter-spacing:.06em}
.tf-pay{font-weight:700;font-size:calc(var(--u)*3.8);line-height:1.4;color:#F4F0E6}
.tf-url{font-weight:800;font-size:calc(var(--u)*4.6);color:#F4A261}
@media (prefers-reduced-motion:reduce){.tf-sc>*,.tf-sc *{animation:none!important}.tf-sc ~ .tf-sc{display:none}.tf-sc>*{opacity:1}}
${kfs}`;
  return { html, css };
}
